<p-card>

    <form [formGroup]="vendorForm">
        <div class="formgrid grid">

            <div class="field col-12 flex justify-content-between align-items-center" style="margin-bottom: 15px;">
                <div>
                    <p-button label="Save" class="p-button-outlined ml-2" icon=" pi pi-save" size="small"
                        (click)="createVendor(vendorForm.value)"></p-button>
                </div>

                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>

            &nbsp;

            <div class="field col-12 flex">
                <div class="flex align-items-center" style="margin: 0px 25px 5px 2px;">
                    <p-checkbox label="Inventory Vendor" formControlName="isInventoryVendor" [binary]="true"
                        value="true"></p-checkbox>
                </div>

                <div class="flex align-items-center" style="margin: 0px 25px 5px 2px;">
                    <p-checkbox label="Internal Vendor" formControlName="isInternalVendor" [binary]="true"
                        value="true"></p-checkbox>
                </div>
            </div>
        </div>


        <div class="grid">

            <div class="col">

                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Vendor Code</label>
                    <div style="display: flex; align-items: center;">
                        <input type="text" pInputText placeholder="e.g V89098" (blur)="checkVendorCode()" class="w-full"
                            formControlName="vendorCode"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorCode.errors }" />
                        <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                                label="Manual Entry" value="true"></p-checkbox>
                        </div>

                    </div>
                    <small *ngIf="submitted && formControls.vendorCode.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>

            </div>


            <div class="col">

                <div class="field text-left">
                    <label for="website" class="label-required display">Vendor Name</label>
                    <input pInputText placeholder="e.g Tom Hank" class="w-full" formControlName="vendorName"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.vendorName.errors }" />
                    <small *ngIf="submitted && formControls.vendorName.errors" id="vendorName-error"
                        class="text-red-500">Required field.</small>
                </div>

            </div>


            <div class="col">

                <div class="field text-left">
                    <label for="website">Vendor Description</label>
                    <input pInputText class="w-full" formControlName="vendorDescription" />
                </div>

            </div>

        </div>

        <p-tabView>
            <p-tabPanel header="General Information">

                <div class="grid ">
                    <div class="col">
                        <div class="field text-left" formGroupName="address">
                            <label for="address" class="label-required display">Address</label>
                            <input pInputText placeholder="Street Address" class="w-full p-inputtext-sm"
                                formControlName="addressLine1"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                id="name-error" class="text-red-500">Required field.</small>
                            <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                                formControlName="addressLine2" />

                            <div class="flex mt-1">
                                <div>
                                    <input pInputText placeholder="City" class="w-full" formControlName="city"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.city.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <!--div class=" ml-1">
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" (onSelect)="setState($event)"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"></p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div-->


                                <div class=" ml-1">
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" (onSelect)="setState($event)"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }">
                                        <ng-template let-state pTemplate="item">
                                            {{ state.stateCode }} - {{ state.stateName }}
                                        </ng-template>
                                    </p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <div class=" ml-1">
                                    <input pInputText placeholder="Zip" class="w-full" formControlName="zip"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.zip.errors" id="name-error"
                                        class="text-red-500">Required field.</small>
                                    <small
                                        *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                                        id="zip-invalid-error" class="text-red-500">Zip code must be exactly 6
                                        digits.</small>

                                </div>

                            </div>
                            <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1"
                                formControlName="country"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <div class="field text-left">
                            <label for="gstin">GSTIN</label>
                            <input pInputText placeholder="GSTIN" class="w-full p-inputtext-sm"
                                formControlName="gstin" />
                        </div>

                    </div>
                    <div class="col ">
                        <div class="field text-left ">
                            <label for="phone">Phone</label>
                            <input min="0" pInputText placeholder="phone" class="w-full p-inputtext-sm"
                                formControlName="phone" (input)="validater()" style="height: 40px;"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors }" />
                            <small *ngIf="submitted && formControls.phone.errors" id="name-error"
                                class="text-red-500">Invalid phone number </small>
                            <small *ngIf="submitted && formControls.phone.hasError('pattern')" id="name-error"
                                class="text-red-500"> Please enter a 10-digit phone number </small>
                            <small *ngIf="submitted && formControls.phone.hasError('maxlength')" id="name-error"
                                class="text-red-500">phone number should not exceed more than 10 </small>
                        </div>
                        <div class="field text-left">
                            <label for="mobile">Mobile</label>
                            <input pInputText placeholder="mobile" class="w-full p-inputtext-sm"
                                formControlName="mobile" (input)="validater()"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }"
                                style="height: 40px;" />
                            <small *ngIf="submitted && formControls.mobile.errors?.['required']" id="name-error"
                                class="text-red-500">Required field.</small>
                            <small *ngIf="submitted && formControls.mobile.errors?.['pattern']" id="name-error"
                                class="text-red-500">Invalid mobile number. Please enter 10-digit mobile number.</small>
                        </div>
                        <div class="field text-left">
                            <label for="email">Email</label>
                            <input pInputText placeholder="Email" class="w-full p-inputtext-sm" formControlName="email"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }"
                                style="height: 40px;" />
                            <small *ngIf="submitted && formControls.email.errors?.['required']" id="name-error"
                                class="text-red-500">Required field.</small>
                            <small *ngIf="submitted && formControls.email.errors?.['email']" id="name-error"
                                class="text-red-500">Invalid email address. Example: xyz&commat;gmail.com.</small>

                        </div>

                        <div>
                            <label for="termsCode"><b>Payment Terms</b></label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText class="w-full p-inputtext-sm" formControlName="termsCode" />
                                <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                    (click)="getTermsCode()"></button>
                            </div>
                        </div>

                    </div>
                </div>

            </p-tabPanel>
        </p-tabView>


    </form>
</p-card>